export default "__VITE_ASSET__zlligUY3__"